var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLove = function SvgLove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 67 65",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 23.192C1 12.555 9.813 4 20.598 4c5.154 0 9.629 2.667 12.902 5.733C36.773 6.667 41.248 4 46.402 4 57.187 4 66 12.555 66 23.192v.054l-.001.029-.008.29c-.036 1.374-.093 3.538-1.015 6.045-.998 2.713-2.925 5.642-6.501 8.692L35.41 59.297a2.844 2.844 0 01-3.822 0L8.525 38.302c-3.576-3.05-5.503-5.98-6.5-8.692-.923-2.507-.98-4.67-1.016-6.046A80.256 80.256 0 001 23.192z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLove;